<!-- A 3D css cube that spins. Used to signify loading -->
<template>
    <div class="scene" :style="{width: size + 'px', height: size + 'px'}">
        <div class="cube"
             :style="{
                 transform: 'translateZ(-100px) ' + 'rotateX(' + rX + 'deg)' + ' rotateY(' + rY + 'deg)' + ' rotateZ(' + rZ + 'deg)',
                 transition: transition,
                 width: size + 'px',
                 height: size + 'px'
             }">
            <div class="cube__face cube__face--front"  :style="{width: size + 'px', height: size + 'px', transform: 'rotateY(0deg) translateZ(' + size/2 + 'px)'}"></div>
            <div class="cube__face cube__face--back"   :style="{width: size + 'px', height: size + 'px', transform: 'rotateY(90deg) translateZ(' + size/2 + 'px)'}"></div>
            <div class="cube__face cube__face--right"  :style="{width: size + 'px', height: size + 'px', transform: 'rotateY(180deg) translateZ(' + size/2 + 'px)'}"></div>
            <div class="cube__face cube__face--left"   :style="{width: size + 'px', height: size + 'px', transform: 'rotateY(90deg) translateZ(' + size/2 + 'px)'}"></div>
            <div class="cube__face cube__face--top"    :style="{width: size + 'px', height: size + 'px', transform: 'rotateX(-90deg) translateZ(' + size/2 + 'px)'}"></div>
            <div class="cube__face cube__face--bottom" :style="{width: size + 'px', height: size + 'px', transform: 'rotateX(90deg) translateZ(' + size/2 + 'px)'}"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PaginationCube",
        props: {
            size: {
                type: Number,
                default: 40
            }
        },
        data() {
            return {
                rX: 55,
                rY: 0,
                rZ: 45,
                isRotating: true,
                transition: 'transform 400ms linear'
            }
        },
        methods: {
            rotate() {
                if (this.isRotating) this.rZ += 100
            },
        },
        created() {
            // Rotates every 400 ms
            this.$options.interval = setInterval(this.rotate, 400)
        },
        beforeDestroy() {
            clearInterval(this.$options.interval)
        }
    }
</script>

<style scoped>
    .scene {
        perspective: 400px;
    }

    .cube {
        position: relative;
        transform-style: preserve-3d;
    }

    .cube__face {
        position: absolute;
        background: hsla(0, 79%, 54%, 1);
        outline: 1px solid transparent; /* triggers AA */
    }
</style>